import { render, staticRenderFns } from "./ReasonNotCaptation.vue?vue&type=template&id=2dfd1285&scoped=true&"
import script from "./ReasonNotCaptation.vue?vue&type=script&lang=js&"
export * from "./ReasonNotCaptation.vue?vue&type=script&lang=js&"
import style0 from "./ReasonNotCaptation.vue?vue&type=style&index=0&id=2dfd1285&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfd1285",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCardActions,VCol,VForm,VIcon,VRow,VSelect,VTextField})
